const english = {
  'TABLES.Column_Title_Name' : 'Name',
  'TABLES.Column_Title_Phone' : 'Phone',
  'TABLES.Column_Title_Email' : 'Email',
  'TABLES.Column_Title_Company' : 'Company',
  'TABLES.Column_Title_Supplier' : 'Supplier',
  'TABLES.Column_Title_User' : 'User',
  'TABLES.Column_Title_Time' : 'Time',
  'TABLES.Column_Title_JobType' : 'Job type',
  'TABLES.Column_Title_Roles' : 'Roles',
  'TABLES.Column_Title_Teams' : 'Teams',
  'TABLES.Column_Title_Type' : 'Type',
  'TABLES.Column_Title_Label' : 'Label',
  'TABLES.Column_Title_Title' : 'Title',
  'TABLES.Column_Title_Status' : 'Status',
  'TABLES.Column_Title_Description' : 'Description',
  'TABLES.Column_Title_ID' : 'ID',
  'TABLES.Column_Sorting_Tooltip_Ascending' : 'Click to sort ascending',
  'TABLES.Column_Sorting_Tooltip_Descending' : 'Click to sort descending',
  'TABLES.Column_Sorting_Tooltip_Cancel' : 'Click to cancel sorting',
  'TABLES.Column_Title_FileName' : 'File name',
  'TABLES.Column_Title_RoleName' : 'Role name',
  'TABLES.Column_Title_NumberRights': 'Number of rights',
  'TABLES.Column_Title_NumberRightsLibrary': 'Number of rights (Library)',
  'TABLES.Column_Title_NumberRightsApp': 'Number of rights (App)',
  'TABLES.Column_Title_NumberUsers' : 'Number of users',
  'TABLES.Column_Title_SupplierName' : 'Supplier name',
  'TABLES.Column_Title_Number' : 'Number',
  'TABLES.Column_Title_UsersNumber' : 'Users Number',
  'TABLES.Column_Title_KeyAmount' : 'Key amount',
  'TABLES.Column_Title_GroupName' : 'Group name',
  'TABLES.Column_Title_Key' : 'Key',
  'TABLES.Column_Title_Editable' : 'Editable',
  'TABLES.Column_Title_Records' : 'Records',
  'TABLES.Column_Title_Found' : 'Found',
  'TABLES.Column_Title_New' : 'New',
  'TABLES.Column_Title_Updated' : 'Updated',
  'TABLES.Column_Title_TeamName' : 'Team name',
  'TABLES.Column_Title_Head' : 'Head',
  'TABLES.Column_Title_NumbProjectManager' : 'Number of project managers',
  'TABLES.Column_Title_NumbDraftsMen' : 'Number of draftsmen',
  'TABLES.Column_Title_Image' : 'Image',
  'TABLES.Column_Title_Article' : 'Article',
  'TABLES.Column_Title_Color' : 'Color',
  'TABLES.Column_Title_NavisionNumb' : 'Navision №',
  'TABLES.Column_Title_OctacadNumb' : 'Octacad №',
  'TABLES.Column_Title_SupplierNumb' : 'Supplier article №',
  'TABLES.Column_Title_ContentLang' : 'Content language',
  'TABLES.Column_Title_Organizer' : 'Organizer',
  'TABLES.Column_Title_Price' : 'Price',
  'TABLES.Column_Title_WholePrice' : 'Whole price (€, per sq.m)',
  'TABLES.Column_Title_BasicFlooringPrice' : '+ to basic flooring (€, per sq.m)',
  'TABLES.Column_Title_SizeMinMax' : 'Size (sqm)',
  'TABLES.Column_Title_PricePer' : 'Price per sqm: (€)',
  'TABLES.Column_Title_Orientations' : 'Orientations',
  'TABLES.Column_Title_RuleType' : 'Rule type',
  'TABLES.Column_Title_StandSizeSqm' : 'Stand size (sqm)',
  'TABLES.Column_Title_Amount' : 'Amount',
  'TABLES.Column_Title_NumberStands' : 'Number of stands',
  'TABLES.Column_Title_NumberEquipment' : 'Number of equipment',
  'TABLES.Column_Title_NumberFlooring' : 'Number of flooring',
  'TABLES.Column_Title_Logo' : 'Logo',
  'TABLES.Column_Title_PrintingCompany' : 'Printing company',
  'TABLES.Column_Title_Leistungscode' : 'Service description',
  'TABLES.Column_Title_EPFertigungListe' : 'Single price production list',
  'TABLES.Column_Title_EPMontageWerkstatt' : 'Single price assembly in workshop',
  'TABLES.Column_Title_EPMontageStand' : 'Single price assembly on stand',
  'TABLES.Column_Title_Lettering' : 'Lettering',
  'TABLES.Column_Title_3dModel' : '3d model',
  'TABLES.Column_Title_Slug' : 'Slug',
  'TABLES.Column_Title_Action' : 'Action',
  'TABLES.Column_Title_EntryPoint': 'Entry point',
  'TABLES.Column_Title_ExhibitionTypes': 'Exhibition types',
  'FORM_RULES.Min_NewPassword' : 'Password must be at least { minLength } characters',
  'FORM_RULES.Required_NewPassword' : 'Please input new Password',
  'FORM_RULES.Required_ConfirmPassword' : 'Please confirm new password',
  'FORM_RULES.Required_ConfirmPasswordMatch' : 'The entered passworts do not match.',
  'FORM_RULES.Required_Name' : 'Please input name',
  'FORM_RULES.Required_ArticleEquipment' : 'Please input name',
  'FORM_RULES.Required_Surname' : 'Please input surname',
  'FORM_RULES.Required_Email' : 'The input E-mail is not valid',
  'FORM_RULES.Required_Choose': 'Please Choose ',
  'FORM_RULES.Required_ChooseType': 'Please choose type',
  'FORM_RULES.Required_ChooseColor': 'Please choose color',
  'FORM_RULES.Required_Phone' : 'Please input phone',
  'FORM_RULES.Required_Title' : 'Please input title',
  'FORM_RULES.Required_Number' : 'Please input number',
  'FORM_RULES.Required_Where' : 'Please choose where to change the time',
  'FORM_RULES.Required_Password' : 'Please input your Password!',
  'FORM_RULES.Required_RoleName' : 'Please input role name',
  'FORM_RULES.Required_Color' : 'Please input color',
  'FORM_RULES.Required_SupplierName' : 'Please input supplier name',
  'FORM_RULES.Required_Key' : 'Please input key',
  'FORM_RULES.Required_Article' : 'Please input article number',
  'FORM_RULES.Required_SupplierArticle' : 'Please input supplier article',
  'FORM_RULES.Required_OctacadNumb' : 'Please input octacad number',
  'FORM_RULES.Required_NavisionArticle' : 'Please input navision article',
  'FORM_RULES.Required_Price' : 'Please input price',
  'FORM_RULES.Required_StandName' : 'Please input stand name',
  'FORM_RULES.Required_MinSizeSqm' : 'Please input min size',
  'FORM_RULES.Required_MaxSizeSqm' : 'Please input max size',
  'FORM_RULES.Required_PricePerSqm' : 'Please input price',
  'FORM_RULES.Required_SizeMinMax' : 'Please input size',
  'FORM_RULES.Required_Amount' : 'Please input amount',
  'FORM_RULES.Required_RuleType' : 'Please input rule type',
  'FORM_RULES.Required_TeamName' : 'Please input team name',
  'FORM_RULES.Required_OrganizerName' : 'Please input organizer name',
  'FORM_RULES.Required_ExhibitionName': 'Please input exhibition type name',
  'FORM_RULES.Required_ExhibitionTypes': 'Please choose exhibition types',
  'FORM_RULES.Required_Leistungscode' : 'Please input leistungscode',
  'FORM_RULES.Required_EPFertigungListe' : 'Please input EP production list',
  'FORM_RULES.Required_EPMontageWerkstatt' : 'Please input EP assembly work shop',
  'FORM_RULES.Required_EPMontageStand' : 'Please input EP assembly stand',
  'FORM_RULES.Required_FreeCharactersAmount' : 'Please input free characters amount',
  'FORM_RULES.Required_AdditionalPrice' : 'Please input additional price',
  'FORM_RULES.Invalid_Phone': 'The input is not valid phone',
  'FORM_RULES.Required_Organizer': 'Please input organizer',
  'FORM_RULES.Required_PrintingCompany': 'Please input printing company',
  'FORM_RULES.Required_MaxCharacter': 'Maximum length 128 characters',
  'FORMS.Input_Label_Password' : 'Password',
  'FORMS.Input_Label_Login' : 'Login',
  'FORMS.Input_Label_NewPassword' : 'New password',
  'FORMS.Input_Label_ConfirmPassword' : 'Confirm new password',
  'FORMS.Input_Label_Language' : 'Language',
  'FORMS.Input_Label_Name' : 'Name',
  'FORMS.Input_Label_Surname' : 'Surname',
  'FORMS.Input_Label_Phone' : 'Phone',
  'FORMS.Input_Label_Email' : 'Email',
  'FORMS.Input_Label_Title' : 'Title',
  'FORMS.Input_Label_Number' : '№',
  'FORMS.Input_Label_Description' : 'Description',
  'FORMS.Input_Label_Status': 'Status',
  'FORMS.Input_Label_Lettering': 'Lettering',
  'FORMS.Input_Label_IntrfaceLanguage' : 'Please choose interface language',
  'FORMS.Input_Label_ContentLanguage' : 'Please choose content language',
  'FORMS.Input_Label_RoleName' : 'Role name',
  'FORMS.Input_Label_Color' : 'Color',
  'FORMS.Input_Label_BaseColor' : 'Material/Colour group',
  'FORMS.Input_Label_Role' : 'Role',
  'FORMS.Input_Label_SupplierName' : 'Supplier name',
  'FORMS.Input_Label_GroupName' : 'Group name',
  'FORMS.Input_Label_Key' : 'Key',
  'FORMS.Input_Label_EditableKey' : 'Editable key',
  'FORMS.Input_Label_Supplier' : 'Supplier',
  'FORMS.Input_Label_Head' : 'Head',
  'FORMS.Input_Label_TeamName' : 'Team name',
  'FORMS.Input_Label_Team' : 'Team',
  'FORMS.Input_Label_ProjectManagers' : 'Project managers',
  'FORMS.Input_Label_ConstructionManagers' : 'Construction managers',
  'FORMS.Input_Label_AutocadEngineers' : 'Autocad engineers',
  'FORMS.Input_Label_AssignedTeams' : 'Assigned teams',
  'FORMS.Input_Label_Type' : 'Type',
  'FORMS.Input_Label_Article' : 'Article',
  'FORMS.Input_Label_Images' : 'Images',
  'FORMS.Input_Label_SupplierArticle' : 'Supplier article №',
  'FORMS.Input_Label_OctacadArticle' : 'Octacad №',
  'FORMS.Input_Label_NavisionNumb' : 'Navision №',
  'FORMS.Input_Label_Price' : 'Price',
  'FORMS.Input_Label_WholePrice' : 'Whole price',
  'FORMS.Input_Label_BasicFlooringPrice' : '+ to basic flooring',
  'FORMS.Input_Label_StandName' : 'Stand name',
  'FORMS.Input_Label_MinSizeSqm' : 'Min size (sqm)',
  'FORMS.Input_Label_MaxSizeSqm' : 'Max size (sqm)',
  'FORMS.Input_Label_PricePerSqm' : 'Price per sqm (€)',
  'FORMS.Input_Label_Complexity' : 'Complexity',
  'FORMS.Input_Label_MinPrice' : 'Min price (€)',
  'FORMS.Input_Label_MaxPrice' : 'Max price (€)',
  'FORMS.Input_Label_MinWholePrice' : 'Min whole price',
  'FORMS.Input_Label_MaxWholePrice' : 'Max whole price',
  'FORMS.Input_Label_MinBasicFlooringPrice' : 'Min basic flooring price',
  'FORMS.Input_Label_MaxBasicFlooringPrice' : 'Max basic flooring price',
  'FORMS.Input_Label_Orientations' : 'Orientations',
  'FORMS.Input_Label_SignIn' : 'Sign in',
  'FORMS.Input_Label_StandSizeMinSqm' : 'Stand size min (sqm)',
  'FORMS.Input_Label_StandSizeMaxSqm' : 'Stand size max (sqm)',
  'FORMS.Input_Label_Amount' : 'Amount',
  'FORMS.Input_Label_StandRuleType' : 'Stand rule type',
  'FORMS.Input_Label_EquipmentName' : 'Equipment name',
  'FORMS.Input_Label_AddText' : 'Add text',
  'FORMS.Input_Label_OrganizerName' : 'Organizer name',
  'FORMS.Input_Label_Organizer' : 'Organizer',
  'FORMS.Input_Label_EquipmentSuppliers' : 'Equipment suppliers',
  'FORMS.Input_Label_PrintHouseSuppliers' : 'Print house suppliers',
  'FORMS.Input_Label_FlooringSuppliers' : 'Flooring suppliers',
  'FORMS.Input_Label_Logo' : 'Logo',
  'FORMS.Input_Label_ExhibitionName' : 'Exhibition Type name',
  'FORMS.Input_Label_ExhibitionTypes' : 'Exhibition Types',
  'FORMS.Input_Label_Organizers' : 'Organizers',
  'FORMS.Input_Label_Materials' : 'Print materials',
  'FORMS.Input_Label_ColorsOracal' : 'Colors (Oracal)',
  'FORMS.Input_Label_AssemblyTypes' : 'Assembly Types',
  'FORMS.Input_Label_PrintingCompany' : 'Printing company',
  'FORMS.Input_Label_Leistungscode' : 'Leistungscode',
  'FORMS.Input_Label_EPFertigungListe' : 'EP Fertigung Liste',
  'FORMS.Input_Label_EPMontageWerkstatt' : 'EP Montage Werkstatt',
  'FORMS.Input_Label_EPMontageStand' : 'EP Montage Stand',
  'FORMS.Input_Label_FreeCharactersAmount' : 'Free characters amount',
  'FORMS.Input_Label_AdditionalPrice': 'Additional price',
  'FORMS.Input_Label_NameArticle' : 'Name of article',
  'FORMS.Input_Label_NameOfArticle': 'Name of article',
  'FORMS.Input_Label_Model3d': '3D Model',
  'FORMS.Input_Label_3DModelUrl': '3D model URL',
  'FORMS.Input_Label_Slug' : 'Slug',
  'FORMS.Input_Label_Action' : 'Action',
  'FORMS.Input_Label_EntryPoint': 'Entry point',
  'FORMS.Input_Label_JobType': 'Job type',
  'FORMS.Title_ChangePassword' : 'Change password',
  'FORMS.Title_SendPassword' : 'Send password',
  'FORMS.Title_AddUsers' : 'Add users',
  'FORMS.Title_ChooseType' : 'Choose type',
  'FORMS.Title_Text_Filters' : 'Filters',
  'FORMS.Title_Text_AddEquipmentRule' : 'Add new equipment rule',
  'FORMS.Title_Text_EditEquipmentRule' : 'Edit equipment rule',
  'FORMS.Title_Text_AddFlooringStand' : 'Add new flooring to the stand type',
  'FORMS.Title_Text_AddFlooringExhibition' : 'Add new flooring to the exhibition type',
  'FORMS.Title_Text_AddStandExhibition' : 'Add new stand type to the exhibition type',
  'FORMS.Title_Text_AddFlooringOrganizer' : 'Add new flooring to the organizer',
  'FORMS.Title_Text_AddStandOrganizer' : 'Add new stand type to the organizer',
  'FORMS.Title_Text_EditFile' : 'Edit file',
  'FORMS.Title_AddNote' : 'Add note',
  'FORMS.Title_Text_EditNote' : 'Edit note',
  'FORMS.Title_EditFile' : 'Edit file',
  'FORMS.Title_AddRoles' : 'Add roles',
  'FORMS.Title_CreateNewKey' : 'Create new key',
  'FORMS.Title_EditKey' : 'Edit key',
  'FORMS.Title_AddSupplier' : 'Add supplier',
  'FORMS.Title_SelectSupplier' : 'Select supplier',
  'FORMS.Title_SelectPrintingCompany' : 'Select printing company',
  'FORMS.Title_AddHead' : 'Add head',
  'FORMS.Title_AddProjectManagers' : 'Add project managers',
  'FORMS.Title_AddConstructionManagers' : 'Add construction managers',
  'FORMS.Title_AddAutocadEngineers' : 'Add autocad engineers',
  'FORMS.Title_AddTeams' : 'Add teams',
  'FORMS.Title_AddOrientations' : 'Add orientations',
  'FORMS.Title_CreateVariation' : 'Create variation',
  'FORMS.Title_EditVariation' : 'Edit variation',
  'FORMS.Title_CreatePriceVariation' : 'Create price variation',
  'FORMS.Title_EditPriceVariation' : 'Edit price variation',
  'FORMS.Title_AddSubstitude' : 'Add substitute',
  'FORMS.Title_ChooseEquipment' : 'Choose equipment',
  'FORMS.Title_UploadFile' : 'Upload file',
  'FORMS.Title_AddEquipmentSuppliers' : 'Add equipment suppliers',
  'FORMS.Title_AddPrintHouseSuppliers' : 'Add print house suppliers',
  'FORMS.Title_AddFlooringSuppliers' : 'Add flooring suppliers',
  'FORMS.Title_AddOrganizer': 'Add organizer',
  'FORMS.Title_SelectOrganizer' : 'Select organizer',
  'FORMS.Title_Text_AddEquipmentOrganizer' : 'Add new equipment articles',
  'FORMS.Title_Text_AddEquipmentExhibition' : 'Add new equipment to the exhibition type',
  'FORMS.Title_AddExhibitionTypes' : 'Add exhibition types',
  'FORMS.Title_AddOrganizers' : 'Add organizers',
  'FORMS.Title_AddGraphicMaterials' : 'Add print materials',
  'FORMS.Title_AddGraphicColorsOracal' : 'Add graphic colors (Oracal)',
  'FORMS.Title_AddAssemblyTypes' : 'Add assembly location',
  'FORMS.Title_EditGraphicRule' : 'Edit graphic prices',
  'FORMS.Title_AddPrintingCompany' : 'Add printing company',
  'FORMS.Title_CreateGraphicRule' : 'Create graphic rule',
  'FORMS.Title_Add3DModel': 'Add 3D model',
  'FORM_RULES.Required_3DModelUrl': 'Please input 3D model URL',
  'FORM_RULES.Invalid_Url': 'Please enter a valid URL (http/https)',
  'FORMS.Select_OptionLabel_NotAssigned' : 'Not assigned',
  'FORMS.Select_OptionLabel_TypeNotSet' : 'Type not set',
  'FORMS.Select_OptionLabel_English' : 'English',
  'FORMS.Select_OptionLabel_Deutsch' : 'Deutsch',
  'FORMS.Select_OptionLabel_ChooseColor' : 'Choose Color',
  'FORMS.Select_OptionLabel_Active' : 'Active',
  'FORMS.Select_OptionLabel_Blocked': 'Blocked',
  'FORMS.Select_OptionLabel_Full' : 'Full',
  'FORMS.Select_OptionLabel_CAD' : 'CAD',
  'FORMS.Input_Placeholder_Email' : 'Email',
  'FORMS.Input_Placeholder_Password' : 'Password',
  'FORMS.Input_Placeholder_Choose' : 'Please Choose',
  'FORMS.Input_Placeholder_ChooseColor' : 'Choose Color',
  'FORMS.Input_Placeholder_Name' : 'Name',
  'FORMS.Input_Placeholder_PleaseChose' : 'Please choose',
  'FORMS.Input_Placeholder_NotAssigned' : 'Not assigned',
  'FORMS.Headig_Text_AppRights' : 'App user rights',
  'FORMS.Headig_Text_LibraryRights' : 'Library - role rights',
  'FORMS.Headig_Text_Special' : 'Special',
  'FORMS.Headig_Text_User' : 'User',
  'FORMS.Headig_Text_Exhibitions' : 'Exhibitions',
  'FORMS.Headig_Text_Description' : 'Description',
  'FORMS.Headig_Text_Organizers' : 'Organizers',
  'FORMS.Button_Text_ApplyFilters' : 'Apply Filters',
  'FORMS.Button_Text_ResetFilters' : 'Reset filters',
  'FORMS.Button_Text_Filters' : 'Filters',
  'FORMS.Button_Text_Reset' : 'Reset',
  'SEARCH.Input_Placeholder_Table_User' : 'Search for name, email, phone',
  'SEARCH.Input_Placeholder_MultiSelect' : 'Search',
  'GLOBAL.Button_Text_Save' : 'Save',
  'GLOBAL.Button_Text_Send' : 'Send',
  'GLOBAL.Button_Text_SaveSend' : 'Save and send',
  'GLOBAL.Button_Text_SaveChanges' : 'Save changes',
  'GLOBAL.Button_Text_CreateNew' : 'Create new',
  'GLOBAL.Button_Text_Create' : 'Create',
  'GLOBAL.Button_Text_Cancel' : 'Cancel',
  'GLOBAL.Button_Text_Delete' : 'Delete',
  'GLOBAL.Button_Text_Remove' : 'Remove',
  'GLOBAL.Button_Text_Confirm' : 'Confirm',
  'GLOBAL.Button_Text_Upload' : 'Upload',
  'GLOBAL.Button_Text_Login' : 'Login',
  'GLOBAL.Button_Text_BackHome' : 'Back Home',
  'GLOBAL.Modal_Text_UserSendPass' : 'Are you sure you want to send a{ br }new password?',
  'GLOBAL.Modal_Text_RemoveText' : 'Are you sure you want to remove this { deleteObjectType }?',
  'GLOBAL.Modal_Text_DeleteText' : 'Are you sure you want to delete this { deleteObjectType }?',
  'GLOBAL.Modal_Text_ResetFilters' : 'Reset filters',
  'GLOBAL.Button_Text_AddNew' : 'Add new',
  'GLOBAL.Button_Text_AddKey' : 'Add key',
  'GLOBAL.Button_Text_Creat' : 'Create',
  'GLOBAL.Button_Text_DeleteGroup' : 'Delete group',
  'GLOBAL.Button_Text_DeleteItem' : 'Delete item',
  'GLOBAL.Button_Text_DeleteStand' : 'Delete stand',
  'GLOBAL.Button_Text_AddTranslation' : 'Add translation',
  'GLOBAL.Button_Text_AddMore' : 'Add more',
  'GLOBAL.Button_Text_AddFile' : 'Add file',
  'GLOBAL.Button_Text_AddDescription' : 'Add description',
  'GLOBAL.Button_Text_AddRule' : 'Add rule',
  'GLOBAL.Button_Text_EditRule' : 'Edit rule',
  'GLOBAL.Button_Text_Add' : 'Add',
  'GLOBAL.Button_Text_Edit' : 'Edit',
  'GLOBAL.Button_Text_DeleteFile' : 'Delete file',
  'GLOBAL.Button_Text_UploadNew' : 'Upload new',
  'GLOBAL.Button_Text_AddNote' : 'Add note',
  'GLOBAL.Button_Text_DeleteNote' : 'Delete note',
  'GLOBAL.Button_Text_DeleteOrganizer' : 'Delete organizer',
  'GLOBAL.Button_Text_AddOrganizer' : 'Add organizer',
  'GLOBAL.Text_NoData' : 'No Data',
  'GLOBAL.Text_Status_Disabled' : 'Disabled',
  'GLOBAL.Text_Status_InProgress' : 'In progress',
  'GLOBAL.Text_Status_Completed' : 'Completed',
  'GLOBAL.Text_AddImage' : 'Add image',
  'GLOBAL.Text_AddLogo' : 'Add logo',
  'GLOBAL.Text_Active' : 'Active',
  'GLOBAL.Text_Blocked' : 'Blocked',
  'GLOBAL.Text_Sqm': 'sq.m',
  'GLOBAL.Text_AllRights': 'All rights',
  'GLOBAL.Button_Text_Add3DModel': '3D model link',
  'GLOBAL.Text_3DModelUnavailable': '3D model unavailable',
  'GLOBAL.Text_LinkUploaded': 'Link uploaded',
  'MODAL.Button_Text_AddRole' : 'Add role',
  'MODAL.Button_Text_AddMore' : 'Add more',
  'MODAL.Button_Text_AddTeam' : 'Add team',
  'MODAL.Button_Text_AddSupplier' : 'Add supplier',
  'MODAL.Button_Text_AddOrientation' : 'Select orientation',
  'MODAL.Button_Text_AddExhibitionType': 'Add exhibition type',
  'MODAL.Button_Text_LogoSize' : 'min. 220 x 65',
  'MODAL.Button_Text_ImgSize' : 'min. 800 x 800',
  'MODAL.Title_Text_SuppliersFileImporting' : 'The suppliers file is importing…',
  'MODAL.Title_Text_SuppliersFileImported' : 'The suppliers file has been imported:',
  'ENTITY.Modal_Title_User' : 'User',
  'ENTITY.Modal_Title_Role' : 'Role',
  'ENTITY.Modal_Title_Supplier' : 'Supplier',
  'ENTITY.Modal_Title_Key' : 'Key',
  'ENTITY.Modal_Title_Group' : 'Group',
  'ENTITY.Modal_Title_Flooring' : 'Flooring',
  'ENTITY.Modal_Title_FlooringVariation' : 'Flooring price variation',
  'ENTITY.Modal_Title_Equipment' : 'Equipment',
  'ENTITY.Modal_Title_Variation' : 'Variation',
  'ENTITY.Modal_Title_Stand' : 'Stand',
  'ENTITY.Modal_Title_StandEquipment' : 'Basic stand equipment',
  'ENTITY.Modal_Title_File' : 'File',
  'ENTITY.Modal_Title_Note' : 'Note',
  'ENTITY.Modal_Title_Team' : 'Team',
  'ENTITY.Modal_Title_Organizer' : 'Organizer',
  'ENTITY.Modal_Title_ExhibitionType' : 'Exhibition type',
  'ENTITY.Modal_Title_StandType' : 'Stand type',
  'ENTITY.Modal_Title_Graphic' : 'Graphic',
  'ENTITY.Modal_Title_GraphicRule': 'Graphic rule',
  'ENTITY.Modal_Title_Permission': 'Permission',
  'MENUS_DROP.Label_Users' : 'Users',
  'MENUS_DROP.Label_Logout' : 'Logout',
  'MENUS_DROP.Label_Edit' : 'Edit',
  'MENUS_DROP.Label_SendPass' : 'Send password',
  'MENUS_DROP.Label_Delete' : 'Delete',
  'MENUS_DROP.Label_Organizers' : 'Organizers',
  'MENUS_DROP.Label_Suppliers' : 'Suppliers',
  'MENUS_DROP.Label_Teams' : 'Teams',
  'MENUS_DROP.Label_StandTypes' : 'Stand types',
  'MENUS_DROP.Label_Equipment' : 'Equipment',
  'MENUS_DROP.Label_Flooring' : 'Flooring',
  'MENUS_DROP.Label_Settings' : 'Settings',
  'MENUS_DROP.Label_MyProfile' : 'My profile',
  'MENUS_DROP.Label_UploadIcon' : 'Upload icon',
  'MENUS_DROP.Label_MakeDefault' : 'Make default',
  'MENUS_DROP.Label_Permissions' : 'Permissions',
  'NAVBAR_PAGES.Label_Overview' : 'Details',
  'NAVBAR_PAGES.Label_Users' : 'Users',
  'NAVBAR_PAGES.Label_UserRoles' : 'User roles',
  'NAVBAR_PAGES.Label_VariableLists' : 'Variable list',
  'NAVBAR_PAGES.Label_Variations' : 'Variations',
  'NAVBAR_PAGES.Label_Substitude' : 'Substitute article',
  'NAVBAR_PAGES.Label_Equipments' : 'Equipment',
  'NAVBAR_PAGES.Label_Equipment' : 'Equipment',
  'NAVBAR_PAGES.Label_Floorings' : 'Flooring',
  'NAVBAR_PAGES.Label_Flooring' : 'Flooring',
  'NAVBAR_PAGES.Label_PriceVariations' : 'Price variations',
  'NAVBAR_PAGES.Label_Files' : 'Files',
  'NAVBAR_PAGES.Label_Notes' : 'Notes',
  'NAVBAR_PAGES.Label_Organizers' : 'Organizers',
  'NAVBAR_PAGES.Label_ExhibitionTypes' : 'Exhibition types',
  'NAVBAR_PAGES.Label_StandTypes' : 'Stand types',
  'NAVBAR_PAGES.Label_GraphicRules' : 'Graphic rules',
  'NAVBAR_PAGES.Label_Rules' : 'Rules',
  'NAVBAR_PAGES.Label_Permissions' : 'Permissions (Developer only)',
  'BREADCRUMBS.Label_Users' : 'Users',
  'BREADCRUMBS.Label_Roles' : 'User roles',
  'BREADCRUMBS.Label_Create' : 'Create',
  'BREADCRUMBS.Label_Suppliers' : 'Suppliers',
  'BREADCRUMBS.Label_VariableLists' : 'Variable list',
  'BREADCRUMBS.Label_Teams' : 'Teams',
  'BREADCRUMBS.Label_Flooring' : 'Flooring',
  'BREADCRUMBS.Label_PriceVariations' : 'Price variations',
  'BREADCRUMBS.Label_Equipment' : 'Equipment',
  'BREADCRUMBS.Label_Variations' : 'Variations',
  'BREADCRUMBS.Label_Substitude' : 'Substitute article',
  'BREADCRUMBS.Label_StandTypes' : 'Stands types',
  'BREADCRUMBS.Label_Equipments' : 'Equipments',
  'BREADCRUMBS.Label_Floorings' : 'Floorings',
  'BREADCRUMBS.Label_Files' : 'Files',
  'BREADCRUMBS.Label_Notes' : 'Notes',
  'BREADCRUMBS.Label_Organizers' : 'Organizers',
  'BREADCRUMBS.Label_Exhibitions' : 'Exhibition types',
  'BREADCRUMBS.Label_ExhibitionCreate' : 'Create exhibition type',
  'BREADCRUMBS.Label_GraphicRules' : 'Graphic rules',
  'BREADCRUMBS.Label_Rules' : 'Rules',
  'BREADCRUMBS.Label_Permissions' : 'Permissions',
  'PAGES.Title_CreateGroup' : 'Create Group',
  'PAGES.Title_Dashboard' : 'Dashboard',
  'PAGES.Title_Users' : 'Users',
  'PAGES.Title_CreateUser' : 'Create User',
  'PAGES.Title_CreateRole' : 'Create User Role',
  'PAGES.Title_CreateSupplier' : 'Create Supplier',
  'PAGES.Title_CreateFlooring' : 'Create Flooring',
  'PAGES.Title_CreateEquipment' : 'Create equipment article',
  'PAGES.Title_CreateTeam' : 'Create Team',
  'PAGES.Title_Suppliers' : 'Suppliers',
  'PAGES.Title_Settings' : 'Settings',
  'PAGES.Title_Teams' : 'Teams',
  'PAGES.Title_Flooring' : 'Flooring',
  'PAGES.Title_Equipment' : 'Equipment',
  'PAGES.Title_StandTypes' : 'Stand Types',
  'PAGES.Title_CreateStand' : 'Create Stand',
  'PAGES.Title_Organizers' : 'Organizers',
  'PAGES.Title_CreateOrganizer' : 'Create Organizer',
  'PAGES.Title_Exhibitions' : 'Exhibition Types',
  'PAGES.Title_CreateExhibition' : 'Create Exhibition Type',
  'PAGES.Title_CreateGraphicRules' : 'Create Graphic Rules',
  'PAGES.Title_Permissions' : 'Permissions',
  'PAGES.Title_CreatePermission' : 'Create Permission',
  'PAGES.Text_404' : 'Sorry, the page you searched for does not exist.',
  'PAGES.Text_403' : 'Sorry, you do not have permission to access this page.',
  'CARD.Info_List_BaseColor' : 'Color group',
  'CARD.Info_List_Type' : 'Material group',
  'CARD.Info_List_Supplier' : 'Supplier',
  'CARD.Info_List_OctacadNumb' : 'Octacad №',
  'CARD.Info_List_SupplierNumb' : 'Supplier article №',
  'CARD.Info_List_NavisionNumb' : 'Navision №',
  'CARD.Info_List_Size' : 'Size',
  'CARD.Info_List_PricePer' : 'Price per sqm',
  'CARD.Info_List_Default' : 'Default',
  'STANDTYPE.Equipment_Rule_EQ' : 'Equal',
  'STANDTYPE.Equipment_Rule_GTE' : 'Greater than/equal',
  'STANDTYPE.Equipment_Rule_LTE' : 'Less than/equal ',
  'STANDTYPE.Equipment_Rule_BETWEEN' : 'Between',
  'VARIABLE.Label_EMPTY' : '! NO TRANSLATION !',
  'USER.Button_Text_Delete' : 'Delete User',
  'ROLE.Button_Text_Delete' : 'Delete Role',
  'SUPPLIER.Button_Text_Delete' : 'Delete Supplier',
  'SUPPLIER.Button_Text_Import' : 'Import suppliers',
  'TEAM.Button_Text_Delete' : 'Delete Team',
  'ORGANIZER.Button_Text_Delete' : 'Delete Organizer',
  'EXHIBITION.Button_Text_Delete' : 'Delete exhibition type',
  'GRAPHIC.Button_Text_Delete' : 'Delete graphic',
  'PERMISSION.Button_Text_Delete' : 'Delete Permission',
  'PERMISSION.Error_AccessDenied' : 'Access denied',
  'PERMISSION.Error_FailedToLoad' : 'Failed to load user permissions',
  'PERMISSION.Error_NoPermission' : 'You do not have permission to perform this action',
  'PERMISSION.Error_NoAccessToSystem' : 'You do not have access to the system. Please contact your administrator.',
  'PERMISSION.Error_NoAccessToAnyPage' : 'You do not have access to any page in the system. Please contact your administrator.',
  'TEAM_ROLES.project_manager' : 'Project manager',
  'TEAM_ROLES.construction_manager' : 'Construction manager',
  'TEAM_ROLES.draftsmen' : 'Autocad engineer',
};

export default english;
